import { useEffect, useState } from "react";
import { Star, StarBorder, StarHalf, TaskAlt } from "@mui/icons-material"
import { dummyfeedbacks } from "../../utils/arrays"
import { Shuffle, formatTimestampToDate } from "../../utils/functions";



const Productratings = ({ action, product }) => {

    const [ratingstodisplay, setratingstodisplay] = useState([]);

    useEffect(() => {
        if (action === 'all') {
            setratingstodisplay(Shuffle(dummyfeedbacks))
        } else {
            setratingstodisplay(Shuffle(dummyfeedbacks).slice(0, 3))
        }
    }, [product, action]);



    const percentage = (number) => {
        const fraction = Math.round((number / product?.item_ratings?.length) * 100)
        return fraction;
    }

    const average = (parseInt(product.ratingTotal) / product?.item_ratings?.length)?.toString().substring(0, 3);

    return (
        <div className="wraproductrating">
            <div className="productratingleft">
                VERIFIED RATINGS ({product?.item_ratings?.length ? product?.item_ratings?.length : 10})
                <div className="ratingbox">
                    <div className="ratingaverage">{average == 'NaN' ? 3.5 : average}/5</div>
                    <Stars rating={average == 'NaN' ? 3.5 : average} />
                    <div className="verifiedtext">{product?.item_ratings?.length ? product?.item_ratings?.length : 10} verified ratings</div>
                </div>
                <div className="ratingsbreakdown">
                    <div className="wrapsinglebreakdown">
                        <div className="wrapnumberadstar">
                            <div className="starratingnumber">5</div>
                            <Star color="primary" sx={{ fontSize: 14 }} />
                        </div>
                        <div className="usersttotalrating">({product.ratingStar5})</div>
                        <div className="starslider">
                            <div className="starslideractive" style={{ width: percentage(product.ratingStar5) }} />
                            <div className="starsliderinactive" />
                        </div>
                    </div>
                    <div className="wrapsinglebreakdown">
                        <div className="wrapnumberadstar">
                            <div className="starratingnumber">4</div>
                            <Star color="primary" sx={{ fontSize: 14 }} />
                        </div>
                        <div className="usersttotalrating">({product.ratingStar4})</div>
                        <div className="starslider">
                            <div className="starslideractive" style={{ width: percentage(product.ratingStar4) }} />
                            <div className="starsliderinactive" />
                        </div>
                    </div>
                    <div className="wrapsinglebreakdown">
                        <div className="wrapnumberadstar">
                            <div className="starratingnumber">3</div>
                            <Star color="primary" sx={{ fontSize: 14 }} />
                        </div>
                        <div className="usersttotalrating">({product.ratingStar3 ? product.ratingStar3 : 10})</div>
                        <div className="starslider">
                            <div className="starslideractive" style={{ width: product.ratingStar3 ? percentage(product.ratingStar3) : "40%" }} />
                            <div className="starsliderinactive" />
                        </div>
                    </div>
                    <div className="wrapsinglebreakdown">
                        <div className="wrapnumberadstar">
                            <div className="starratingnumber">2</div>
                            <Star color="primary" sx={{ fontSize: 14 }} />
                        </div>
                        <div className="usersttotalrating">({product.ratingStar2})</div>
                        <div className="starslider">
                            <div className="starslideractive" style={{ width: percentage(product.ratingStar2) }} />
                            <div className="starsliderinactive" />
                        </div>
                    </div>
                    <div className="wrapsinglebreakdown">
                        <div className="wrapnumberadstar">
                            <div className="starratingnumber">1</div>
                            <Star color="primary" sx={{ fontSize: 14 }} />
                        </div>
                        <div className="usersttotalrating">({product.ratingStar1})</div>
                        <div className="starslider">
                            <div className="starslideractive" style={{ width: percentage(product.ratingStar1) }} />
                            <div className="starsliderinactive" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="productratingright">
                <div>PRODUCT REVIEWS ({product?.item_ratings?.length})</div>
                {product?.item_ratings?.map((val, key) => {

                    return (
                        <div className="wrapfeedback" key={key}>
                            <div className="feebackstar"><Stars rating={val.RATING} /></div>
                            <div className="feedbacktitle">{val.TITLE}</div>
                            <div className="feedbackcomment">{val.COMMENT}</div>
                            <div className="wrapfeedbackdates">
                                <div className="feedbackdate">{formatTimestampToDate(val.DATE_CREATED)}&nbsp; by {val.CUSTOMER_NAME}</div>
                                <div className="verifiedbutton">
                                    <TaskAlt />
                                    Verified Purchase
                                </div>
                            </div>
                        </div>
                    )
                })}
                {product?.item_ratings?.length < 1 && <div className="noreviews">No Reviews</div>}
            </div>

        </div>
    )
}

export default Productratings



const Stars = ({ rating }) => {
    // Calculate the number of full stars and half stars
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    // Create an array to store the star components
    const starsArray = [];

    // Add full stars
    for (let i = 0; i < fullStars; i++) {
        starsArray.push(<Star key={i} />);
    }

    // Add half star if necessary
    if (hasHalfStar) {
        starsArray.push(<StarHalf key="half" />);
    }

    // Fill the rest with empty stars
    const totalStars = 5;
    while (starsArray.length < totalStars) {
        starsArray.push(<StarBorder color="p" key={starsArray.length} />);
    }

    return <div className="clientstars">{starsArray}</div>;
};
